(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurewood-shop-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    document.querySelectorAll('.aw-shop:not(.aw-shop--mobile)[open]').forEach(function(menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.aw-shop:not(.aw-shop--mobile)[open]').forEach(function(menu) {
      menu.open = false; menu.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurewood-size-enquiry"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-aw-size-enquiry]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const fallback = button.closest('.aw-size-enquiry').querySelector('.aw-size-enquiry__fallback');
    fallback.hidden = true;
    button.disabled = true;
    function openChat() {
      const modern = document.querySelector('shopify-chat');
      if (modern && customElements.get('shopify-chat')) {
        modern.setAttribute('open', '');
        return true;
      }
      const legacy = document.querySelector('#ShopifyChat');
      if (legacy) {
        if (legacy.getAttribute('is-open') === 'true') return true;
        const toggle = legacy.shadowRoot?.querySelector('.chat-app > button, button.chat-toggle');
        if (toggle) {
          if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
          return true;
        }
      }
      return false;
    }
    try {
      let opened = false;
      for (let attempt = 0; attempt < 8; attempt++) {
        if (openChat()) { opened = true; break; }
        await new Promise(resolve => setTimeout(resolve, 350));
      }
      fallback.hidden = opened;
    } catch (_) {
      fallback.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
